import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  ProfitAndLossStatementStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { requiredFiles } from '../../useValidateQuestionnaire';

export const fields: IBaseField<
  keyof ProfitAndLossStatementStateValues | any
>[] = [
  {
    name: 'doYouHaveAProfitAndLossStatementPreparedForYear',
    label: 'Do you have a profit and loss statement prepared for {year}?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'pleaseUploadYourProfitAndLossStatements',
        label: 'Please upload your profit and loss statements.',
        type: 'upload',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
      },

      {
        dependenciesTitle: 'Profit and Loss Revenue',
        name: 'revenue',
        label: 'Revenue',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },
      {
        name: 'returnsRefunds',
        label: 'Returns/Refunds',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },
      {
        dependenciesTitle: 'Expenses',
        name: 'accounting',
        label: 'Accounting',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'advertising',
        label: 'Advertising',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'bankCharges',
        label: 'Bank Charges',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'commissions',
        label: 'Commissions',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'comupterAndInternet',
        label: 'Comupter and Internet',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'contractLabor',
        label: 'Contract Labor',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'domainFees',
        label: 'Domain Fees',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'duesAndSubscriptions',
        label: 'Dues and Subscriptions',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'entertainment',
        label: 'Entertainment',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'healthInsurance',
        label: 'Health Insurance',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'interest',
        label: 'Interest',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'liabilityInsurance',
        label: 'Liability Insurance',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'marketing',
        label: 'Marketing',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'meals',
        label: 'Meals',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'officeExpense',
        label: 'Office Expense',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'outsideServices',
        label: 'Outside Services',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'parkingAndTolls',
        label: 'Parking and Tolls',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'postageAndDelivery',
        label: 'Postage and Delivery',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'printing',
        label: 'Printing',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'rent',
        label: 'Rent',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'repairsAndMaintenance',
        label: 'Repairs and Maintenance',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'seminarsAndTraining',
        label: 'Seminars and Training',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'supplies',
        label: 'Supplies',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'taxes',
        label: 'Taxes',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'telephone',
        label: 'Telephone',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'travel',
        label: 'Travel',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'utilities',
        label: 'Utilities',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'wages',
        label: 'Wages',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
      },

      {
        name: 'otherExpensesList',
        label: 'Other Expenses',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'number',
            effect: updateKeyInStore(updateKey),

            comment: true,
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'no',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
